export const networkList = [
  {
    name: 'Ethereum',
    id: '1',
    rpcUrls: ['https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161'],
    nativeCurrency: 'ETH',
  },
  // @TODO uncomment
  // { name: 'Fantom Opera', id: '250', rpcUrls: ['https://rpc.ftm.tools/'], nativeCurrency: 'FTM' },
  // { name: 'Optimism', id: '10', rpcUrls: ['https://optimistic.etherscan.io'], nativeCurrency: 'ETH' },
];
